import React from "react";
import {defineBlock, smartProps, useEditor, EditableImg} from "@smartfire/wordpress-react";
import style from "./block.module.scss";

function Block(){
    const {isEditing} = useEditor();

    return <div  className={style.block + " slider-image"}>
        <div  className={style.content}>
            <div  className={isEditing? style.editImage : style.image} >
                <EditableImg smartProp="image"/>
            </div>
        </div>
    </div>

}

export default defineBlock({
    Block,
    smartProps: {
        image:smartProps.any.withDefault(),
    }, 
    setup: {
        title: "Slider Item",
        parent:['smartfire/slider']
    }
});
